<!-- @format -->

<ad-search-tag>
    <style>
        .job_list .job_list-item {
            border: #49868E 2px solid;
            border-radius: 6px;
            margin: 0 0 16px;
            padding: 16px 8px;
        }

        .accordion_body {
            display: none
        }

        .container_accordion .accordion_heading {
            font-size: 1.5em;
            font-weight: bold;
        }
    </style>
    <div class="container_breadcrumb">
        <ul class="breadcrumb">
            <li class="breadcrumb-item"><a href="/ad" class="recruitment">公募案件を探す</a></li>
            <li class="breadcrumb-item"><h1>検索条件設定</h1></li>
        </ul>
    </div><!--/.container_breadcrumb-->

    <div class="contents">

        <section class="contents_area">

            <div class="contents_block">
                <div class="container_heading">
                    <h2 class="heading-02 heading_search">検索条件設定</h2>
                </div>

                <template each={page_key in Object.keys(def.page_groups)}>
                    <div class="container_accordion">
                        <div class="accordion_heading is-hide" onclick={e=>toggleAccordion(e)}>
                            [{def.page_groups[page_key].num}] {def.page_groups[page_key].jname}
                        </div>
                        <div class="accordion_body" style="display:none">

                            <div class="wrap_group"
                                 each={wrap_group in Object.keys(def.page_groups[page_key].wrap_groups)}>

                                <div class="accordion_heading02">
                                    <div class="checkbox_wrap">
                                        <input type="checkbox"
                                               id="{def.page_groups[page_key].wrap_groups[wrap_group].name||def.page_groups[page_key].name}"
                                               class="checkbox-input checkall" onchange={e=>checkAll(e.target)}>
                                        <label for="{def.page_groups[page_key].wrap_groups[wrap_group].name||def.page_groups[page_key].name}"
                                               class="checkbox-parts">{def.page_groups[page_key].wrap_groups[wrap_group].jname || def.page_groups[page_key].jname}</label>
                                    </div>
                                </div><!--/.accordion_heading02-->

                                <template
                                        each={sub_group in def.page_groups[page_key].wrap_groups[wrap_group].sub_group}>
                                    <h4 class="heading-04 margin-spacing-2_top" if={sub_group.title_jp}>
                                        {sub_group.title_jp}</h4>
                                    <ul class="search-checkbox_list margin-spacing-1_top">
                                        <li class="search-checkbox_list-item" each={k in Object.keys(sub_group.items)}>
                                            <input type="checkbox"
                                                   id="{sub_group.form_item_name}_{sub_group.items[k].id}"
                                                   class="checkbox-input vip" data-group-name="" data-sub-title=""
                                                   onchange={e=>showCheckedItems(e.target)}>
                                            <label for="{sub_group.form_item_name}_{sub_group.items[k].id}"
                                                   class="checkbox-parts">{sub_group.items[k].jname}</label>
                                        </li>
                                    </ul>
                                </template>


                            </div>

                        </div>
                        <!--/.accordion_body-->
                    </div>
                    <div class="selected"></div>


                </template>

            </div><!--/.contents_block-->

            <div class="contents_block margin-spacing-3_top">
                <div class="container_heading">
                    <h2 class="heading-02 heading_search">フリー検索</h2>
                </div>
                <div class="box_flex02 margin-spacing-2_top">
                    <div class="box_w50">
                        <input class="text_input" type="text" name="freeword" id="freeword" placeholder="ホンダ"
                               data-title="ホンダ">
                    </div>
                </div>

            </div><!--/.contents_block-->

            <div class="contents_block margin-spacing-3_top">
                <div class="container_heading">
                    <h2 class="heading-02 heading_search">報酬金額</h2>
                </div>
                <div class="box_flex02 margin-spacing-2_top">
                    <div class="box_w20">
                        <input class="text_input" type="text" name="price" id="price" placeholder="10,000"
                               data-title="報酬金額">
                    </div>
                    <div class="margin-spacing-2_left">円以上</div>
                </div>

            </div><!--/.contents_block-->

            <div class="box_flex03 margin-spacing-2_top">
                <div class="button button-secondary-large" type="button" value="この条件で検索する" data-target=""
                     onclick={e=>search(e)}>この条件で検索する
                </div>
            </div>

        </section><!--/.contents_area-->

    </div><!--/.contents-->

    <script>
        import di from "dependency-injection";

        export default {
            def: {
                page_groups: {}
            },
            details: [],
            state: {},
            isArray(obj) {
                if (Array.isArray(obj.items) && obj.items.length > 0) return true;
                return false;
            },
            checkAll(e) {
                const group = e.closest('.wrap_group');
                group.querySelectorAll('input[type=checkbox]')
                    .forEach(checkbox => checkbox.checked = e.checked);
                this.showCheckedItems(e);
            },
            showCheckedItems(e) {
                const top = e.closest('.accordion_body');
                const selectedDiv = e.closest('.container_accordion').nextElementSibling;
                selectedDiv.innerHTML = '';

                const groups = {};
                const sub_groups = {};
                top.querySelectorAll('ul > li > input[type=checkbox]:checked')
                    .forEach(checkbox => {
                        const group_name = checkbox.getAttribute('data-group-name');
                        const sub_title = checkbox.getAttribute('data-sub-title') || '';
                        if (!groups[group_name]) groups[group_name] = {};
                        if (!groups[group_name][sub_title]) groups[group_name][sub_title] = new Array();
                        groups[group_name][sub_title].push(checkbox.nextElementSibling.innerText);


                        //labels.push(checkbox.nextElementSibling.innerText);

                    });
                Object.keys(groups).forEach(key => {
                    const h3h5 = document.createElement('h3');
                    h3h5.innerHTML = `<h3 class="heading-05 margin-spacing-1_bottom">${key}</h3>`;
                    selectedDiv.append(h3h5);
                    Object.keys(groups[key]).forEach(subkey => {
                        if (subkey) {
                            const h3h4 = document.createElement('h3');
                            h3h4.innerHTML = `<h3 class="heading-04 margin-spacing-1_bottom">${subkey}</h3>`;
                            selectedDiv.append(h3h4);
                        }
                        const ul = document.createElement('ul');
                        ul.classList.add('scope_list');
                        ul.classList.add('margin-spacing-1_bottom');
                        groups[key][subkey].forEach(name => {
                            const li = document.createElement('li');
                            li.innerHTML = `<span class="skill_label">${name}</span>`;
                            li.classList.add('scope_list-item');
                            ul.append(li);
                        });
                        selectedDiv.append(ul);
                    });
                });


            },
            toggleAccordion(e) {
                if (e.target.nextElementSibling.style.display === 'none') {
                    e.target.classList.remove('is-hide');
                    e.target.nextElementSibling.style.display = 'block';
                } else {
                    e.target.classList.add('is-hide');
                    e.target.nextElementSibling.style.display = 'none';
                }

            },
            search(e) {
                const saveData = {};
                this.$$('input.vip[type=checkbox]:checked').forEach(item => {
                    saveData[item.id] = item.value;
                });
                di.SyncBox.set('ad-search-saveData', saveData);

                /*
                let inputs = this.$$('input');
                const checkboxes = {};
                const inputTexts = {};
                inputs.forEach(item=>{
                  if (item.type == 'checkbox' && item.checked) {
                    if (!$(item).hasClass('js-check_all') && !$(item).hasClass('js-other_check')) {
                      checkboxes[item.name] = $(`label[for=${item.name}]`).text();
                    }
                  }else if (item.type == 'text' && item.value) {
                    inputTexts[item.name] = {
                      'title': $(item).data('title'),
                      'value': item.value
                    };
                  }
                });
                di.SyncBox.set('ad-search-checkboxes', checkboxes);
                di.SyncBox.set('ad-search-inputTexts', inputTexts);
                */
                di.router.push('/ad');
            },
            onBeforeMount() {
                this.api = di.createApi('ad');
                this.api.request('search', 'fetch-ad-definitions')
                    .then(data => {
                        this.def = data;
                        window.def = data;

                        Object.keys(def.page_small_group_names).forEach(page_key => {
                            const page_group = {};

                            def.page_small_group_names[page_key].forEach(small_group_name => {
                                const group_name = def.item_format_for_pages[page_key][small_group_name].group_name;
                                const group_jname = def.item_format_for_pages[page_key][small_group_name].group_jname;
                                if (!page_group[group_name]) {
                                    page_group[group_name] = {
                                        name: group_name,
                                        jname: group_jname,
                                        sub_group: new Array()
                                    };
                                }
                                page_group[group_name].sub_group.push(def.item_format_for_pages[page_key][small_group_name])
                            });
                            def.page_groups[page_key].wrap_groups = page_group;
                        })

                        this.update()
                    });

                /*
                        .then(data=>{
                          const details = new Array();
                          details.push({
                            groups: {
                              "web": {
                                "jname": "Webメディア",
                                "items": []
                              }
                            }
                          });

                          data.forEach((val,idx)=>{
                            details[idx].title = val.title;
                            Object.keys(val.data).forEach(key=>{
                              details[idx]['groups'][  val.data[key]['group_name'] ]['items'].push(val.data[key]);
                            })
                          });
                          this.details = details;
                          this.update();



                          const saveData = di.SyncBox.get('ad-search-saveData');
                          if (saveData) {
                            Object.keys(saveData).forEach(id=>{
                              const target = this.$(`#${id}`);
                              target.checked = true;
                            });
                            this.$$('input.checkall[type=checkbox]').forEach(item=>{
                              this.showCheckedItems(item);
                            });
                            //
                          }
                        })
                */

            },
            onMounted(props, state) {


                /*
                const checkboxes = di.SyncBox.get('ad-search-checkboxes');
                const inputTexts = di.SyncBox.get('ad-search-inputTexts');
                if (checkboxes) {
                  Object.keys(checkboxes).forEach(key=>{
                    this.$(`input[name=${key}]`).checked = true;
                  });
                }
                if (inputTexts) {
                  Object.keys(inputTexts).forEach(key=>{
                    const target = this.$(`input[name=${key}]`);
                    target.value = inputTexts[key].value;
                    if (target.hasAttribute('data-checkbox')) {
                      target.disabled = false;
                      const checkbox = target.getAttribute('data-checkbox');
                      this.$(`input[name=${checkbox}]`).checked = true;
                    }
                  });
                }
                */

            }
        }
    </script>
</ad-search-tag>
